import React, { useEffect } from 'react'
import bootstrap from 'bootstrap'
import $ from 'jquery'
function Privacy({ toggleModal }) {
    useEffect(() => {
        const init = () => {
            $('#privacyModal').modal('show');
            $('#privacyModal').on('hidden.bs.modal', function (e) {
                setTimeout(() => {
                    toggleModal();
                }, 150);
            });
        }
        init();
        //eslint-disable-next-line
    }, [])
    const handleShowHide = (e) => {
        // console.log('called');
        e.preventDefault();
        var $elem = $(e.target);
        var $target = $('.faded');
        var totalHeight = 0;
        if ($target.hasClass('show')) {
            $target.removeClass('show');
            $elem.html('Show More <i class="fa fa-angle-down"></i>');
            $target.animate({
                "height": '100px'
            });

        } else {
            $target.addClass('show');
            $elem.html('Show Less <i class="fa fa-angle-up"></i>');
            var $ps = $target.find('p');
            $ps.each(function () {
                totalHeight += $(this).outerHeight();
            });
            $target.animate({
                "height": totalHeight + 22
            });
        }
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        var $form = $(event.target),
            $action = $form.attr('action');
        if ($form.find('*[name="phone"]').val().length < 14) {
            $form.find('*[name="phone"]').addClass('is-invalid');
            return;
        }
        $.ajax({
            url: $action,
            method: 'GET',
            data: $form.serialize(),
            success: (e) => {
                toggleOverlay();
            },
            error: (e) => {
                $('#contactModal .overlay').removeClass('active');
                $('#contactModal .inner-modal').addClass('active');

            }
        })

    }
    const toggleOverlay = () => {
        $('#contactModal .overlay').toggleClass('active');
        $('#contactModal .inner-modal').toggleClass('active');
    }
    return (
        <div className="modal fade" id="privacyModal" tabIndex="-1" role="dialog">
            <div className="modal-dialog modal-dialog-centered modal-xl" role="document">

                <div className="modal-content">
                    <div className="modal-body">

                        <button type="button" class="close close-btn" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">×</span>
                        </button>
                        <h3>Privacy Policy</h3>
                        <h5>Privacy Notice</h5>
                        <p>This privacy notice discloses the privacy practices for (www.cocard.com). This privacy notice applies solely to information collected by this website, except where stated otherwise. It will notify you of the following: What information we collect; With whom it is shared; How it can be corrected; How it is secured; How policy changes will be communicated; and How to address concerns over misuse of personal data.</p>
                        <h5>Information Collection, Use, and Sharing </h5>
                        <p>
                            We are the sole owners of the information collected on this site. We only have access to/collect information that you voluntarily give us via email or other direct contact from you. We will not sell or rent this information to anyone. We will use your information to respond to you, regarding the reason you contacted us. We will not share your information with any third party outside of our organization, other than as necessary to fulfill your request, e.g., to ship an order. Unless you ask us not to, we may contact you via email in the future to tell you about specials, new products or services, or changes to this privacy policy.
                        </p>
                        <h5>Your Access to and Control Over Information </h5>
                        <p>
                            You may opt out of any future contacts from us at any time. You can do the following at any time by contacting us via the email address or phone number provided on our website: See what data we have about you, if any. Change/correct any data we have about you. Have us delete any data we have about you. Express any concern you have about our use of your data.
                        </p>
                        <h5>Security </h5>
                        <p>
                            We take precautions to protect your information. When you submit sensitive information via the website, your information is protected both online and offline. Wherever we collect sensitive information (such as credit card data), that information is encrypted and transmitted to us in a secure way. You can verify this by looking for a closed lock icon at the bottom of your web browser, or looking for "https" at the beginning of the address of the web page. While we use encryption to protect sensitive information transmitted online, we also protect your information offline. Only employees who need the information to perform a specific job (e.g, billing or customer service) are granted access to personally identifiable information. The computers/servers on which we store personally identifiable information are kept in a secure environment.
                        </p>
                        <h5>Cookies</h5>
                        <p>
                            We use "cookies" on this site. A cookie is a piece of data stored on a site visitor's hard drive to help us improve your access to our site and identify repeat visitors to our site. For instance, when we use a cookie to identify you, you would not have to log in a password more than once, thereby saving time while on our site. Cookies can also enable us to track and target the interests of our users to enhance their experience on our site. Usage of a cookie is in no way linked to any personally identifiable information on our site.
                        </p>
                        <h5>Notification of Changes</h5>
                        <p>
                            Numerous other provisions and/or practices may be required as a result of laws, international treaties, or industry practices. It is up to you to determine what additional practices must be followed and/or what additional disclosures are required. Please take special notice of the California Online Privacy Protection Act (CalOPPA), which is frequently amended and now includes a disclosure requirement for “Do Not Track” signals. <strong>If you feel that we are not abiding by this privacy policy, you should contact us immediately via telephone at <a href="tel:800.577.0195">800.577.0195</a> or via email <a href="mailto:hello@cocard.com">hello@cocard.com</a>.</strong>
                        </p>

                    </div>
                </div>

            </div>
        </div>
    )
}

export default Privacy
